<template>
	<div class="modal-popup bg-content">
		<div class="modal-close text-primary" @click="onClose">
			&times;
		</div>
		<div class="modal-content">
			<div>
				<h2 class="text-primary font-uppercase">
					{{ $tc('modals.modalInviteMember.mainTitleText') }}
				</h2>
				<h3 class="mt-50 text-black font-uppercase">
					{{ $tc('modals.modalInviteMember.subtitleText') }}
				</h3>
				<p class="mt-25 text-black font-regular">
					{{ $tc('modals.modalInviteMember.helperText') }}
				</p>
			</div>
			<div class="mt-50">
				<invite-member-form :team-id="options.teamId" @success="onConfirm" />
			</div>
		</div>
	</div>
</template>

<script>
import InviteMemberForm from '../forms/InviteMemberForm'
import { ModalMixin } from '~/assets/vue/mixins'

export default {
	name: 'ModalInviteMember',
	components: { InviteMemberForm },
	mixins: [ModalMixin],
	props: {
		options: {
			type: Object,
			required: true
		}
	}
}
</script>
